import { render, staticRenderFns } from "./zuzhuanggzMb.vue?vue&type=template&id=5227a5ef&scoped=true&"
import script from "./zuzhuanggzMb.vue?vue&type=script&lang=js&"
export * from "./zuzhuanggzMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227a5ef",
  null
  
)

export default component.exports